import { Component, OnInit } from '@angular/core';
import { Company } from '../../../onboarding/classes/company';
import { Step } from '../../../onboarding/classes/step';
import { CompanyService } from '../../../onboarding/services/company.service';
import { AdminService } from '../../services/admin.service';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss']
})
export class DashboardPageComponent implements OnInit {
  company: Company = <Company>{};
  name: string = '';
  state: any = <any>{};
  steps: any[] = [];
  urls: any;
  incomplete: boolean = false;
  sub: any;
  orgId: number;
  isAdmin: boolean;

  constructor(
    private CompanyService: CompanyService,
    private router: Router,
    private route: ActivatedRoute,
    private AdminService: AdminService,
    private titleService: Title,
    private UserService: UserService
  ) { }

  ngOnInit() {
    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.name = u.first_name;
        this.isAdmin = u.admin;
      })


    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.urls = <any>{
        'Add Users': `/onboarding/user/add/${this.orgId}`,
        'Add Departments': `/onboarding/department/${this.orgId}`,
        'Setup your Organization': `/onboarding/businessinfo/${this.orgId}`,
        'Upload Documents': `/admin/documents/${this.orgId}`,
        'Setup your Vacation Policies': `/onboarding/timeoff/${this.orgId}`,
      };
      this.CompanyService.getCompany(this.orgId)
        .subscribe(company => {
          this.company = JSON.parse(company.organization);
          console.log(this.company)
          this.steps = JSON.parse(company.steps);
          this.incomplete = this.steps.some(s => {
            return !s[2];
          })
          this.state = JSON.parse(company.state);
        })
    });

    this.titleService.setTitle('Admin Dashboard');
  }

  approveOrg() {
    this.AdminService.archiveOrg(this.orgId)
      .subscribe(org => {
        this.router.navigate(['admin/review']);
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/dashboard-page/dashboard-page.component.ts